import { Box, Typography } from '@mui/material';
import { useContext } from 'react';
import '../template.module.css';
import { ReportTemplatesContext } from '..';

export default function ProgressIndicator() {
  const { currentStage, setCurrentStage, lastStage, editing } = useContext(
    ReportTemplatesContext,
  );

  const stages = ['createTemplate', 'customizeTemplate', 'saveAndFinish'];

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        height: '3.6rem',
        paddingX: '2rem',
      }}
    >
      {/*
        4 Stages:
            1. Create Template
            2. Add Maps to Template // removed
            3. Customize Template
            4. Save & Finish
      */}

      {stages.map((stage, index) => (
        <>
          <Box
            key={stage + Date.now()}
            sx={{
              height: '3.6rem',
              width: '60%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.5rem',

              border:
                stage === currentStage
                  ? '1px solid #4FA490'
                  : '1px dashed #DFDFDF',

              borderRadius: '1.25rem',
              cursor:
                editing === true
                  ? 'pointer'
                  : stages.indexOf(stage) <= stages.indexOf(lastStage)
                    ? 'pointer'
                    : 'default',
            }}
            onClick={() => {
              if (!editing) {
                if (stages.indexOf(stage) <= stages.indexOf(lastStage)) {
                  setCurrentStage(stage);
                }
              } else {
                setCurrentStage(stage);
              }
            }}
          >
            <Box
              sx={{
                height: '1.2rem',
                width: '1.2rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid',
                borderColor: stage === currentStage ? '#4FA490' : '#DFDFDF',
                borderRadius: '50%',
              }}
            >
              <Typography
                sx={{
                  fontFamily: 'Lato',
                  fontSize: '0.9rem',
                  fontWeight: 700,
                  lineHeight: '24px',
                  letterSpacing: '0.2px',
                  textAlign: 'center',
                  color: stage === currentStage ? '#212529' : '#DBDAD9',
                }}
              >
                {index + 1}
              </Typography>
            </Box>

            <Typography
              sx={{
                fontFamily: 'Lato',
                fontSize: '0.9rem',
                fontWeight: 700,
                lineHeight: '24px',
                letterSpacing: '0.2px',
                textAlign: 'center',
                color: stage === currentStage ? '#212529' : '#DBDAD9',
              }}
            >
              {
                {
                  createTemplate: 'Create Template',
                  customizeTemplate: 'Customize Template',
                  saveAndFinish: 'Save & Finish',
                }[stage]
              }
            </Typography>
          </Box>
          {/* A straight line in the center */}
          {index !== stages.length - 1 && (
            <Box
              sx={{
                height: '0.1rem',
                width: '10%',
                backgroundColor: '#DFDFDF',
              }}
            ></Box>
          )}
        </>
      ))}
    </Box>
  );
}
